import dayjs, { Dayjs } from 'dayjs';

// The day the merchant picks is the delivery day; the backend resends 24 h before
// `reattempt_at`, so 09:00 Baghdad on day D puts the order on the D−1 picking list.
export const REATTEMPT_HOUR = 9;
export const REATTEMPT_DAY_COUNT = 14;
const CAP_HOURS = 72;
const BAGHDAD_OFFSET_HOURS = 3; // Iraq has no DST

interface StatusPivot {
  slug: string;
  pivot?: { created_at: string };
}

// Baghdad wall clock as a utc-mode dayjs, so .format() prints Baghdad time.
const toBaghdad = (iso: string | Date) => dayjs.utc(iso).add(BAGHDAD_OFFSET_HOURS, 'hour');

/**
 * The selectable delivery days (Baghdad dates): REATTEMPT_DAY_COUNT consecutive days
 * starting from the first whose 09:00 is in the future and more than 72 h after the
 * order's first out-for-delivery — the same rule the backend enforces.
 */
export const reattemptDays = (
  statuses: StatusPivot[] | undefined,
  now: Date = new Date(),
): Dayjs[] => {
  const ofdTimes = (statuses ?? [])
    .filter((s) => s.slug === 'out-for-delivery' && s.pivot?.created_at)
    .map((s) => dayjs.utc(s.pivot?.created_at).valueOf());

  const nowBgd = toBaghdad(now);
  const cap = ofdTimes.length
    ? toBaghdad(new Date(Math.min(...ofdTimes))).add(CAP_HOURS, 'hour')
    : nowBgd;
  const cutoff = cap.isAfter(nowBgd) ? cap : nowBgd;

  let first = cutoff.startOf('day').add(REATTEMPT_HOUR, 'hour');
  if (!first.isAfter(cutoff)) first = first.add(1, 'day');

  return Array.from({ length: REATTEMPT_DAY_COUNT }, (_, i) => first.add(i, 'day'));
};
